<template>
  <div>
    <router-view />
  </div>
</template>

<script>
// import { loadCurrentUser } from '@/auth/api';

export default {
  name: 'RootChrome',
  components: {},
  // created() {
  //   this.loadUser();
  // },
  // methods: {
  //   async loadUser() {
  //     this.$store.dispatch('setIsCurrentUserLoading', true);
  //     try {
  //       const auth = await loadCurrentUser();
  //       if (auth.data.currentAccount) {
  //         await this.$store.dispatch('setCurrentUser', auth.data.currentAccount);
  //         await this.$store.dispatch('setEnvironment', auth.data.environment);
  //       } else {
  //         this.$router.push('/login');
  //       }
  //       await this.$store.dispatch('setIsCurrentUserLoading', false);
  //     } catch (error) {
  //       if (error.response.status === 401 && this.$route.fullPath !== '/login') {
  //         this.$router.push('/login');
  //       }
  //       await this.$store.dispatch('setIsCurrentUserLoading', false);
  //     }
  //   },
  // },
};
</script>

<style lang="scss" scoped>
</style>
